import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Handles Twitch giveaway modal.
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Usage
 * -------
 *
 * <div
 *   data-controller="gift-modal"
 *   data-gift-modal-monthly-value="20"
 *   data-gift-modal-monthly-pretty-value="$20"
 *   <% if annual_offer_id %>
 *     data-gift-modal-annual-value="99"
 *     data-gift-modal-annual-pretty-value="$99"
 *   <% end %>
 * >
 *   <input type="radio" data-action="gift-modal#handleChangeType" data-type="monthly" />
 *
 *   <input type="radio" data-action="gift-modal#handleChangeType" data-type="annual" />
 *
 *   <div data-gift-modal-target="selectContainer">
 *     <div class="select" data-gift-modal-target="selectContainer">
 *        <select data-gift-modal-target="select" data-action="change->gift-modal#handleSelectChange"></select>
 *     </div>
 *   </div>
 *
 *   <div data-gift-modal-target="inputContainer">
 *     <input data-action="input->gift-modal#handleInputChange" data-gift-modal-target="input" />
 *   </div>
 *
 *   <button data-action="click->gift-modal#handleSubmit">Checkout</button>
 * </div>
 */
export default class default_1 extends Controller {
    static targets = ['selectContainer', 'select', 'inputContainer', 'input', 'confirmButton'];
    static values = {
        monthly: Number,
        monthlyPretty: String,
        annual: Number,
        annualPretty: String,
    };
    type = 'monthly';
    setButtonContent(value) {
        this.confirmButtonTarget.innerHTML = `Checkout ($${value / 100})`;
    }
    handleChangeType(e) {
        if (!(e.target instanceof HTMLInputElement))
            return;
        this.type = e.target.dataset['type'];
        if (this.selectTarget.classList.contains('hidden')) {
            this.handleInputChange();
        }
        else {
            this.handleSelectChange();
        }
    }
    handleInputChange() {
        const value = parseInt(this.inputTarget.value);
        if (value && value > 0) {
            this.setButtonContent(value * this.typeValue);
        }
    }
    handleSelectChange() {
        const value = parseInt(this.selectTarget.value);
        if (value && value > 0) {
            if (value === 10) {
                // Hide select
                this.selectContainerTarget.classList.add('hidden');
                this.selectTarget.disabled = true;
                // Show input
                this.inputContainerTarget.classList.remove('hidden');
                this.inputTarget.disabled = false;
                this.inputTarget.value = '10';
                this.inputTarget.focus();
            }
            this.setButtonContent(value * this.typeValue);
        }
    }
    get typeValue() {
        return this.type === 'monthly' ? this.monthlyValue : this.annualValue;
    }
}
